module.exports = __webpack_public_path__ + "static/media/custom-ex-9.41c9de8d.jpg";